import React from "react";
import TheftIcon from "../assets/Icons/theft.png";
import HeartAttackIcon from "../assets/Icons/heartattack.png";
import BombIcon from "../assets/Icons/Bom.png";
import FireIcon from "../assets/Icons/fire.png";
import FloodIcon from "../assets/Icons/flood.png";
import EpilepsyIcon from "../assets/Icons/epilepsy.png";
import ShockIcon from "../assets/Icons/shock.png";
import HighVoltageIcon from "../assets/Icons/highvoltage.png";
import ShortCircuitIcon from "../assets/Icons/shortcircuit.png";
import AllergyIcon from "../assets/Icons/pinda.svg";
import ChokingIcon from "../assets/Icons/choking.png";
import AsylumIcon from "../assets/Icons/asylum.png";
import CutIcon from "../assets/Icons/cutwounded.png";
import EyeInjuryIcon from "../assets/Icons/eyeinjury.png";
import DrowningIcon from "../assets/Icons/drowning.svg";
import BurnsIcon from "../assets/Icons/burnaccident.png";
import EarthquakeIcon from "../assets/Icons/earthquake.svg";
import FaintingIcon from "../assets/Icons/fainting.png";
import HyperventilationIcon from "../assets/Icons/hyperventilation.png";
import InsectBiteIcon from "../assets/Icons/insectbite.png";
import DiabetesIcon from "../assets/Icons/diabetes.svg";
import PoisoningIcon from "../assets/Icons/poison1.png";
import StrokeIcon from "../assets/Icons/stroke.png";
import BoneFractureIcon from "../assets/Icons/bonefracture.png";
import SkullFractureIcon from "../assets/Icons/skullfracture.png";
import SpinalFractureIcon from "../assets/Icons/spinalfracture.png";

export const rootCauseTypes = [
  {
    label: "Heart-Attack",
    value: "Heart-Attack",
    icon: HeartAttackIcon,
  },
  {
    label: "Bomb-Threatening",
    value: "Bomb-Threatening",
    icon: BombIcon,
  },
  {
    label: "Fire",
    value: "Fire",
    icon: FireIcon,
  },
  {
    label: "Flood",
    value: "Flood",
    icon: FloodIcon,
  },
  {
    label: "Theft",
    value: "Theft",
    icon: TheftIcon,
  },
  {
    label: "Epilepsy",
    value: "Epilepsy",
    icon: EpilepsyIcon,
  },
  {
    label: "Shock",
    value: "Shock",
    icon: ShockIcon,
  },
  {
    label: "HighVoltageCable",
    value: "HighVoltageCable",
    icon: HighVoltageIcon,
  },
  {
    label: "Shortcircuit",
    value: "Shortcircuit",
    icon: ShortCircuitIcon,
  },
  {
    label: "Food Allergy",
    value: "Food Allergy",
    icon: AllergyIcon,
  },
  {
    label: "Choking",
    value: "Choking",
    icon: ChokingIcon,
  },
  {
    label: "Asylum",
    value: "Asylum",
    icon: AsylumIcon,
  },
  {
    label: "Cut",
    value: "Cut",
    icon: CutIcon,
  },
  {
    label: "Eyeinjury",
    value: "Eyeinjury",
    icon: EyeInjuryIcon,
  },
  {
    label: "Drowning",
    value: "Drowning",
    icon: DrowningIcon,
  },
  {
    label: "Burns",
    value: "Burns",
    icon: BurnsIcon,
  },
  {
    label: "Earthquake",
    value: "Earthquake",
    icon: EarthquakeIcon,
  },
  {
    label: "Fainting",
    value: "Fainting",
    icon: FaintingIcon,
  },
  {
    label: "Hyperventilation",
    value: "Hyperventilation",
    icon: HyperventilationIcon,
  },
  {
    label: "Insectbite",
    value: "Insectbite",
    icon: InsectBiteIcon,
  },
  {
    label: "Diabetes",
    value: "Diabetes",
    icon: DiabetesIcon,
  },
  {
    label: "Poisoning",
    value: "Poisoning",
    icon: PoisoningIcon,
  },
  {
    label: "Stroke",
    value: "Stroke",
    icon: StrokeIcon,
  },
  {
    label: "Bonefracture",
    value: "Bonefracture",
    icon: BoneFractureIcon,
  },
  {
    label: "Skullfracture",
    value: "Skullfracture",
    icon: SkullFractureIcon,
  },
  {
    label: "Spinalfracture",
    value: "Spinalfracture",
    icon: SpinalFractureIcon,
  },
];

const serviceTypeSelector = ({ value, onChange }) => {
  return (
    <div>
      <label htmlFor="serviceType">service Type</label>
      <select
        id="serviceType"
        name="serviceType"
        value={value}
        onChange={onChange}
      >
        <option value="">-- Select a Service Type --</option>
        {rootCauseTypes.map((type, index) => (
          <option key={index} value={type}>
            {type}
          </option>
        ))}
      </select>
    </div>
  );
};

export default serviceTypeSelector;
